import NavigationClose from '@assets/icons/navigation/navigation-close.svg'
import NavigationOpen from '@assets/icons/navigation/navigation-open.svg'
import { selectThemeStyle } from '../../../features/setting/setting.slice.ts'
import { useAppSelector } from '../../../redux/hooks'
import Toolbox from '@assets/icons/navigation/toolbox.svg'
import Tasks from '@assets/icons/navigation/tasks.svg'
import Notice from '@assets/icons/navigation/notice.svg'
import React from 'react'
import { UserInfo } from '../../../apis/auth/auth.def.ts'
import { UserDropdown } from './user/user-dropdown.tsx'
import { IdeyaButton } from '../../antd/ideya-button/ideya-button.tsx'
import { isV2Ready } from '../../../utils/helpers.ts'

interface HeaderItemProps {
  userInfo: UserInfo
  collapsed: boolean
  onCollapseClicked: () => void
  navigationLabel: string
  mobile?: boolean
}

export const HeaderItems: React.FC<HeaderItemProps> = ({
  userInfo,
  collapsed,
  onCollapseClicked,
  navigationLabel,
  mobile = false,
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)

  if (mobile) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <UserDropdown fullName={userInfo.fullName} />
      </div>
    )
  }

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <IdeyaButton
          type={'text'}
          icon={collapsed ? <NavigationOpen /> : <NavigationClose />}
          onClick={onCollapseClicked}
          style={{
            cursor: 'default',
            backgroundColor: 'transparent',
            color: themeStyle.naviText,
          }}
        >
          {navigationLabel}
        </IdeyaButton>
      </div>
      <div
        style={{
          paddingRight: themeStyle.paddingXL,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {isV2Ready && (
          <>
            <HeaderIconButton icon={<Toolbox />} label={'Toolbox'} />
            <HeaderIconButton icon={<Tasks />} label={'Tasks'} />
            <div style={{ margin: '0px 8px' }}>
              <div
                style={{
                  width: '1px',
                  height: '16px',
                  backgroundColor: themeStyle.colorSplit,
                }}
              />
            </div>
            <IdeyaButton
              type={'text'}
              style={{
                cursor: 'default',
                backgroundColor: 'transparent',
                color: themeStyle.naviText,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                padding: '0px 0px',
              }}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%',
                  width: '24px',
                  position: 'relative',
                }}
              >
                <Notice />
              </span>
            </IdeyaButton>
            <div style={{ margin: '0px 16px 0px 8px' }}>
              <div
                style={{
                  width: '1px',
                  height: '16px',
                  backgroundColor: themeStyle.colorSplit,
                }}
              />
            </div>
          </>
        )}
        <UserDropdown fullName={userInfo.fullName} />
      </div>
    </>
  )
}

interface HeaderIconButtonProps {
  icon: React.ReactNode
  label?: string
}

const HeaderIconButton: React.FC<HeaderIconButtonProps> = ({
  icon,
  label = '',
}) => {
  const themeStyle = useAppSelector(selectThemeStyle)

  return (
    <IdeyaButton
      type={'text'}
      style={{
        cursor: 'default',
        backgroundColor: 'transparent',
        color: themeStyle.naviDropdownIcon,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '23px',
        }}
      >
        {icon}
      </span>
      {label}
    </IdeyaButton>
  )
}
